export default __webpack_public_path__ + "static/media/FXC_MAP_HD.b7e87400.jpg";